module.exports = __webpack_public_path__ + "img/shape-octagon-estrella.ae3bb9c4.png";